import { useContext, useState } from "react";
import styled from "styled-components";
import ModalContext from "components/contexts/ModalContext";
import client from "api/WookAxios";
import { AiOutlineClose } from "react-icons/ai";
import log from "loglevel";
import { toast } from "sonner";
import { parseErrors, parseFieldError } from "lib/errors/parse";
import { REGISTER_TOKEN } from "constants/auth";
import { useNavigate } from "react-router-dom";
import { FieldError } from "components/common/FieldError";
import { handleThrottle } from "lib/errors/handle";

const ModalFrame = styled.div`
  // display: ${(props) => (props.$visible ? "flex" : "none")};
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  background: rgb(45, 49, 45, 0.5);
  z-index: 1010;
`;

const Modal = styled.div`
  box-sizing: border-box;
  position: relative;
  top: 80px;
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  align-items: center;
  border-radius: 20px;
  width: 350px;
  height: 570px;
  margin: 0 auto;
  background: #fafbfa;
  background: white;
  opacity: 1;
`;

const Title = styled.div`
  // height: 40px;
  // background: red;
  width: 280px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 35px;
  font-weight: 500;
  color: #464646;
  padding-top: 10px;
  padding-left: 10px;
`;

const Description = styled.div`
  width: 280px;
  // background: red;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  // font-weight: 500;
  color: #262626;
  padding-top: 20px;
  padding-bottom: 5px;
`;

const Description2 = styled.div`
  width: 280px;
  // background: red;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 14px;
  // font-weight: 500;
  color: blue;
  // padding-top: 30px;
  padding-bottom: 10px;
`;

const StyledForm = styled.form`
  width: 280px;
  padding: 15px 0;
  // background: red;
`;

const Label = styled.label`
  // width: 280px;
  // background: red;
  padding-left: 5px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  // font-weight: 500;
  color: #262626;
`;

const Error = styled.label`
  // width: 280px;
  // background: red;
  padding-left: 5px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  // font-weight: 500;
  color: red;
`;

const StyledInput = styled.input`
  width: 98.5%;
  height: 35px;
  box-sizing: border;
  border-radius: 4px;
  border: none;
  margin-bottom: 15px;
  background: #eeeeee;

  // outline: none;

  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;

  &::placeholder {
    color: #black;
  }

  &:focus {
    color: black;
  }
`;

const StyledSubmit = styled.input`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  border: none;
  background: pink;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  color: #363636;
  margin-top: 10px;
`;

const StatusBar = styled.div`
  box-sizing: border-box;  
  width: 280px;
  padding-top: 12px;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: flex-end;
  // background: red;
`;

const TextButton = styled.div`
  color: blue;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-size: 15px;
  &:hover {
    background: lightgray;
  }
`;

const RegisterCheckModal = ({ onSuccess }) => {
  const [fieldError, setFieldError] = useState({});
  const navigate = useNavigate();
  
  const validateRegisterCheckField = (representative, president, dummy) => {
    const errors = {};

    const requiredFields = {representative, president, dummy};
    Object.entries(requiredFields).forEach(([field, value]) => {
      if (!value?.trim()) {
        errors[field] = '필수 입력';
      }
    });

    return Object.keys(errors).length > 0 ? errors : null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const representative = e.target.representative.value;
    const president = e.target.president.value;
    const dummy = e.target.dummy.value;

    const errors = validateRegisterCheckField(representative, president, dummy);
    if (errors) {
      setFieldError(errors);
      return;
    }

    const registerCheckData = {
      representative: representative,
      president: president,
      dummy: dummy,
    };
    
    try {
      const response = await client.registerCheck(registerCheckData);
      log.debug('AUTH_REGISTER_CHECK_SUCCESS', response);
      sessionStorage.setItem(REGISTER_TOKEN, response.data.register_token);
      toast.success("정답입니다! 회원 가입을 진행합니다.");
      onSuccess();
    } catch (e) {
      log.debug('AUTH_REGISTER_CHECK_FAILED', e.response);
      const throttled = handleThrottle(e.response);
      if (throttled) return;
      setFieldError(parseFieldError(e.response));
    }
  };

  const handleClose = () => {
    navigate('/');
  };

  const onTest = () => {
    document.querySelector('.RegisterCheck input[name="representative"]').value = '노정준';
    document.querySelector('.RegisterCheck input[name="president"]').value = '김성욱';
    document.querySelector('.RegisterCheck input[name="dummy"]').value = '토마스';
  };

  return (
    <div className="RegisterCheck">
      <ModalFrame>
        <Modal>
          <Title>Quiz</Title>
          <Description>
            이 사이트는 <br />
            서울대학교 치과대학 2005학년도 동기만 <br />
            회원 가입할 수 있습니다. <br />
            이를 확인하는 질문에 올바로 답해주세요.<br />
          </Description>
          <Description2>
            회원가입 이후에 적합한 자격이 의심되는 경우<br />
            임의로 계정이 비활성화 될 수 있습니다.
          </Description2>
          <StyledForm onSubmit={handleSubmit}>
            <Label>초대 과대 이름</Label><FieldError message={fieldError.representative} size={14} inline />
            <StyledInput name="representative" placeholder=""/>
            <Label>총대 이름</Label><FieldError message={fieldError.president} size={14} inline />
            <StyledInput name="president" placeholder="" />
            <Label>5층 실습실 더미 애칭</Label><FieldError message={fieldError.dummy} size={14} inline />
            <StyledInput name="dummy" placeholder="" />
            <StyledSubmit type="submit" value="답안지 제출" />
          </StyledForm>
          <StatusBar>
            {process.env.NODE_ENV === 'development' && 
              <button onClick={onTest} style={{ marginRight: '80px' }}>Go</button>
            }
            <TextButton onClick={handleClose}>취소</TextButton>
          </StatusBar>
        </Modal>
      </ModalFrame>
    </div>
  );
};

export default RegisterCheckModal;